<template>
  <FormContainer withoutDivider>
    <template #title>Informations</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_8"
          v-model="referenceInterneModel"
          label="Référence interne de l'entreprise"
          :required="meta.formation?.referenceFormationInterneEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.referenceFormationInterneEntreprise?.$messageErreurDirty!"
          class="col-8 col-md-12 col-sm-36"
          hint="15 caractères maximum"
          :maxlength="15"
          deletable
          :readonly
          help="Ce champ vous permet de renseigner une référence propre à votre entreprise"
        />
      </div>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_9"
          v-model="typeQualificationModel"
          label="Type de certification visée"
          key-id="id"
          key-label="label"
          :required="meta.formation?.typeQualification?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.typeQualification?.$messageErreurDirty!"
          class="col-18 col-sm-36"
          :items="typeQualificationItems"
          :readonly
        />
        <div class="col-18 col-sm-none"></div>
        <WrapperAutocomplete
          v-if="meta.formation?.rncp?.code?.$status !== PropertyStatus.NotPresent"
          id="field_10"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="rncpModel"
          :search="searchRNCP"
          label="Code RNCP"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="3"
          placeholder="Ex: boulangerie ou 39257"
          :readonly
          strict
          :required="meta.formation?.rncp?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.rncp?.code?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_10"
          :search="searchRNCP"
          label="Code RNCP"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          placeholder="Ex: boulangerie ou 39257"
          disabled
        />
        <WrapperAutocomplete
          v-if="meta.formation?.repertoireSpecifique?.code?.$status !== PropertyStatus.NotPresent"
          id="field_unknown"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="repertoireSpeficiqueModel"
          :search="searchRepertoireSpeficiqueClea"
          label="Répertoire spécifique (RS)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="0"
          placeholder="Ex: Socle de connaiss... ou 6269"
          :readonly
          strict
          :required="meta.formation?.repertoireSpecifique?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.repertoireSpecifique?.code?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_unknown"
          :search="searchRepertoireSpeficiqueClea"
          label="Répertoire spécifique (RS)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          placeholder="Ex: Socle de connaiss... ou 6269"
          disabled
        />
        <WarningRncp
          class="col-36"
          :rncp="rncpModel"
          :date-conclusion="dateDebutContrat"
          :isAvenant="false"
          :get-rncp
          :readonly
        />
        <WrapperAutocomplete
          v-if="meta.formation?.nsf?.code?.$status !== PropertyStatus.NotPresent"
          id="field_12"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          v-model="nsfModel"
          :search="searchNsfSelonTypeQualification"
          label="Spécialité (NSF)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="0"
          placeholder="Ex: Formations générales ou 100"
          :readonly
          strict
          :required="meta.formation?.nsf?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.nsf?.code?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_12"
          :search="searchNsfSelonTypeQualification"
          label="Spécialité (NSF)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          placeholder="Ex: Formations générales ou 100"
          disabled
        />
        <WrapperDropdown
          id="field_certification_visee"
          v-model="certificationViseeModel"
          label="Certification visée"
          key-id="code"
          key-label="intitule"
          :required="meta.formation?.certificationVisee?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.certificationVisee?.$messageErreurDirty!"
          class="col-18 col-sm-36"
          :items="lov.Diplome"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_11"
          :model-value="model?.formation?.intitule"
          label="Intitulé précis"
          :required="meta.formation?.intitule?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.intitule?.$messageErreurDirty!"
          class="col-36"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInputNumber
          id="field_161"
          v-model="dureeTotaleModel"
          label="Durée total de formation"
          :required="meta.formation?.dureeTotale?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeTotale?.$messageErreurDirty!"
          class="col-8 col-md-8 col-sm-36"
          :decimal="2"
          deletable
          :readonly
        />
        <WrapperInputNumber
          id="field_162"
          v-model="dureeTotaleEnseignementModel"
          label="Dont durée des enseignements généraux professionnels et technologiques"
          :required="meta.formation?.dureeEnseignementsGenerauxEtTechnologique?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dureeEnseignementsGenerauxEtTechnologique?.$messageErreurDirty!"
          class="col-8 col-md-8 col-sm-36"
          :decimal="2"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { LovItemDTO, RncpDto, RsDTO } from '@/features/api/extranet/dto/Lov'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import type { TypeQualification } from '@/features/domaine/types/opco/Demande/PROA'
  import { typeQualificationItems } from '@/features/interface/demande/proa/dropdown-items'
  import { FormContainer, WarningRncp } from '@/features/interface/demande/shared'
  import type { SearchNsf, SearchRs } from '@/features/services/demande/DemandeAllService.types'
  import { objectExtract } from '@/features/shared/tools'
  import { storeToRefs } from 'pinia'
  import { computed, inject } from 'vue'
  import { PROA_INJECT, type DemandeProAActions } from '../../../../DemandePROA.type'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'

  const { searchRNCP, searchNsf, searchRs } = inject<DemandeProAActions>(PROA_INJECT)!
  const store = useDemandePROAStore()
  const { setupFieldWithKey, setupFieldWithOptions } = store
  const { model, meta, readonly, lov } = storeToRefs(store)
  const referenceInterneModel = setupFieldWithKey<string>('formation.referenceFormationInterneEntreprise', true)
  const certificationViseeModel = setupFieldWithKey<string>('formation.certificationVisee', true)

  const getLabel = function (value: LovItemDTO<string>) {
    return `${value.code} - ${value.intitule}`
  }

  const typeQualificationModel = setupFieldWithOptions<TypeQualification | null>({
    getValue: () => model.value?.formation?.typeQualification ?? null,
    setPatch: (patch, value) => {
      patch.formation!.typeQualification = value ?? null

      // RNCP
      if (!value || value === 'Clea') {
        patch.formation!.rncp = null
      }

      // RS
      if (!value || value !== 'Clea') {
        patch.formation!.repertoireSpecifique = null
      }

      // NSF
      if (value && model.value?.formation?.typeQualification) {
        if (!['Cqp', 'Rncp'].includes(value) || !['Cqp', 'Rncp'].includes(model.value.formation.typeQualification)) {
          patch.formation!.nsf = null
        }
      } else {
        patch.formation!.nsf = null
      }

      if (!value) {
        patch.formation!.intitule = null
      } else if (value === 'Clea') {
        patch.formation!.intitule = patch.formation?.repertoireSpecifique?.intitule ?? null
      } else if (['Cqp', 'Rncp'].includes(value)) {
        patch.formation!.intitule = patch.formation?.rncp?.intitule ?? null
      }
    },
  })

  const rncpModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: () => model.value?.formation?.rncp ?? null,
    setPatch: (patch, value) => {
      patch.formation!.rncp = value ? objectExtract(value, ['code', 'intitule']) : null
      if (value?.code) {
        patch.formation!.intitule = value?.intitule
        patch.formation!.nsf = null
        const rncp = value as RncpDto
        if (rncp.nsf?.length ?? 0 >= 1) {
          patch.formation!.nsf = rncp.nsf!.at(0)
        }
      } else {
        patch.formation!.intitule = null
        patch.formation!.nsf = null
      }
    },
  })

  const repertoireSpeficiqueModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: () => model.value?.formation?.repertoireSpecifique ?? null,
    setPatch: (patch, value) => {
      patch.formation!.repertoireSpecifique = value ? objectExtract(value, ['code', 'intitule']) : null
      if (value?.code) {
        patch.formation!.intitule = value?.intitule
        patch.formation!.nsf = null

        const rs = value as RsDTO
        if (rs.nsf?.length === 1) {
          patch.formation!.nsf = rs.nsf.at(0)
        }
      } else {
        patch.formation!.intitule = null
        patch.formation!.nsf = null
      }
    },
  })

  const searchNsfSelonTypeQualification = (search: string) => {
    const query: SearchNsf = { search }
    if (meta.value?.formation?.rncp?.code?.$status !== PropertyStatus.NotPresent) {
      query.codeRNCP = rncpModel.value?.code
    }
    if (meta?.value?.formation?.repertoireSpecifique?.code?.$status !== PropertyStatus.NotPresent) {
      query.codeRs = repertoireSpeficiqueModel.value?.code
    }

    return searchNsf(query)
  }

  const searchRepertoireSpeficiqueClea = (search: string) => {
    const query: SearchRs = { search, estClea: true }
    return searchRs(query)
  }

  /* NSF */
  const nsfModel = setupFieldWithOptions<LovItemDTO<string> | null>({
    getValue: (model) => model.formation?.nsf ?? null,
    setPatch: (patch, value) => {
      patch.formation!.nsf = value ? objectExtract(value, ['code', 'intitule']) : null
    },
  })

  /* Warning Rncp */
  const { getRncp } = inject<DemandeProAActions>(PROA_INJECT)!
  const dateDebutContrat = computed(() => model.value?.contrat?.dateDebutExecutionProA)

  /* Durée */
  const dureeTotaleModel = setupFieldWithKey<string>('formation.dureeTotale', true)
  const dureeTotaleEnseignementModel = setupFieldWithKey<string>(
    'formation.dureeEnseignementsGenerauxEtTechnologique',
    true,
  )
</script>
